import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllSharedServicePassengers = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/shared-service-passengers',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveSharedServicePassenger = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/shared-service-passengers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateSharedServicePassenger = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/shared-service-passengers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteSharedServicePassenger = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/shared-service-passengers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllSharedServicePassengers,
  saveSharedServicePassenger,
  deleteSharedServicePassenger,
  updateSharedServicePassenger,
}
